import React from "react";
import { translate } from "react-i18next";
import Button from "../../../components/Button";
import InputForm from "../../../components/InputForm";
import LabelForm from "../../../components/LabelForm";

const AvatarInfo = (props)=>{
    const {t} = props;

    return(
        <>
            <div className="col-xs-12 from-group">
                {props.person.group_rh !== "" &&
                    <div className="col-xs-12 center">
                        <h2 style={{color:"#FF0000", fontWeight:'bold', marginLeft:'15%', margin:'0', fontSize:'80px', fontFamily: 'Roboto Condensed, sans-serif'}}>
                            {props.person.group_rh}
                        </h2>
                    </div>
                }
            </div>
            <div className="col-xs-12 center">
                <div className="col-xs-12 col-sm-10 col-sm-offset-2">
                    <img 
                        src={
                            props.person.photo !== '' ? 'data:image/jpeg;base64,'+props.person.photo : '../../../default_user.jpg'
                        }
                        alt="Foto"
                        className="photo-avatar"
                    />
                </div>
            </div>
            <div className="col-xs-12 col-sm-10 col-sm-offset-2 center">
                <div className="col-xs-12 form-group">
                    <LabelForm text={t('content.modal_hc.donation_type')} />
                    <InputForm id="donation_type" value={props.donation_type} handleChange={props.handleChange} disabled />
                </div>
                <div className="col-xs-12 form-group">
                    <InputForm id="extraction_type" value={props.extraction_type} handleChange={props.handleChange} disabled />
                </div>
                {props.editBtn &&
                    <div className="col-xs-12 center">
                        <Button 
                            text="EDITAR" 
                            class="btn-info" 
                            styles={{marginTop:"5px",fontSize:".7em",backgroundColor:props.colorBtnHistory,border:"0px"}} 
                            action={props.openModalHistorico}
                        />
                    </div>
                }
                <div className="col-xs-12 form-group">
                    <LabelForm text={t('content.modal_hc.donor_number')} />
                    <InputForm id="donor_number" value={props.donor_number} handleChange={props.handleChange} disabled />
                </div>
                {props.historyBtn &&
                    <div className="col-xs-12 center">
                        <Button 
                            text="HISTORICO" 
                            class="btn-success" 
                            styles={{marginTop:"5px",fontSize:".7em",backgroundColor:props.colorBtnHistory,border:"0px"}} 
                            action={props.openModalHistorico}
                        />
                    </div>
                }
            </div>
        </>
    )
}

export default translate('translations') (AvatarInfo);

AvatarInfo.defaultProps = {
    historyBtn:true,
    editBtn:false,
    colorBtnHistory:'',
    openModalHistorico:()=>{}
}